module.exports = __webpack_public_path__ + "img/block4_prog.52add926.png";